export enum EPlatformQueryKey {
  PLATFORMS = 'platforms'
}
